export const coreRoutesConstants = {
  root: {
    path: "/r",
    href: () => "/r"
  },
  app: {
    path: "/r/app",
    href: () => "/r/app"
  },
  dashboard: {
    path: "/r/app/dashboard",
    href: (projectId?: string) =>
      `/r/app/dashboard${projectId ? `?project=${projectId}` : ""}`
  },
  account_settings: {
    path: "/r/app/account_settings",
    href: (projectId?: string) =>
      `/r/app/account_settings${projectId ? `?project=${projectId}` : ""}`
  },
  super_admins: {
    path: "/r/app/account_settings/super_admins",
    href: (projectId?: string) =>
      `/r/app/account_settings/super_admins${
        projectId ? `?project=${projectId}` : ""
      }`
  },
  account_details: {
    path: "/r/app/account_settings/details",
    href: (projectId?: string) =>
      `/r/app/account_settings/details${
        projectId ? `?project=${projectId}` : ""
      }`
  },
  modules_settings: {
    path: "/r/app/account_settings/modules",
    href: (projectId?: string) =>
      `/r/app/account_settings/modules${
        projectId ? `?project=${projectId}` : ""
      }`
  },
  watchtower: {
    path: "/r/app/account_settings/watchtower",
    href: () => `/r/app/account_settings/watchtower`
  },
  watchtower_instance: {
    path: "/r/app/account_settings/watchtower/:instanceId",
    href: (instanceId: number) =>
      `/r/app/account_settings/watchtower/${instanceId}`
  },
  watchtower_auth: {
    path: "/r/app/watchtower/auth",
    href: () => `/r/app/watchtower/auth`
  },
  project_grouping: {
    path: "/r/app/account_settings/project_grouping",
    href: (projectId?: string) =>
      `/r/app/account_settings/project_grouping${
        projectId ? `?project=${projectId}` : ""
      }`
  },
  public: {
    path: "/r/pc",
    href: () => "/r/pc"
  }
} as const;
